import { createGlobalStyle } from 'styled-components'

const GlobalStyles = createGlobalStyle`

  .doris-widget-overflow-hidden {
    overflow: hidden;
  }

  .doris-widget-isolated {
    div,
    button,
    svg,
    img,
    span,
    i,
    h2,
    ul,
    li,
    a,
    section,
    form,
    select,
    option,
    p {
      all: revert;
    }
  }

  #doris-widget {
    *::selection {
      background: transparent;
    }

    * {
      box-sizing: border-box;
      font-family: ${props => props.theme.fontFamily};
    }

    h3,
    h4,
    h5,
    h6,
    figure,
    pre,
    dl,
    dd,
    blockquote,
    input[type="radio"],
    input[type="checkbox"] {
      margin: 0
    }

    // TODO: reset default styles here, on demand
    h2 {
      &:not([class]) {
        margin: 0
      }
    }

    legend {
      padding: 0
    }

    fieldset,
    ol {
      padding: 0;
      margin: 0
    }

    ul,
    ol {
      list-style: none
    }

    figure,
    figcaption,
    img {
      display: block
    }

    img {
      max-width: 100%;
    }

    a {
      text-decoration: none
    }

    fieldset {
      border: 0
    }

    label {
      display: flex
    }

    input[type="text"],
    input[type="email"],
    input[type="password"],
    input[type="search"] {
      -webkit-appearance: none
    }

    button::-moz-focus-inner {
      border: 0
    }

    button {
      cursor: pointer;
    }

    button[disabled] {
      cursor: default;
    }

    .slick-list,.slick-slider,.slick-track{position:relative;display:block}.slick-slider{box-sizing:border-box;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-touch-callout:none;-khtml-user-select:none;-ms-touch-action:pan-y;touch-action:pan-y;-webkit-tap-highlight-color:transparent}.slick-list{overflow:hidden;margin:0;padding:0}.slick-list:focus{outline:0}.slick-list.dragging{cursor:pointer;cursor:hand}.slick-slider .slick-list,.slick-slider .slick-track{-webkit-transform:translate3d(0,0,0);-moz-transform:translate3d(0,0,0);-ms-transform:translate3d(0,0,0);-o-transform:translate3d(0,0,0);transform:translate3d(0,0,0)}.slick-track{top:0;left:0;margin-left:auto;margin-right:auto}.slick-track:after,.slick-track:before{display:table;content:''}.slick-track:after{clear:both}.slick-loading .slick-slide,.slick-loading .slick-track{visibility:hidden}.slick-slide{display:none;float:left;height:100%;min-height:1px}[dir=rtl] .slick-slide{float:right}.slick-initialized .slick-slide,.slick-slide img{display:block}.slick-arrow.slick-hidden,.slick-slide.slick-loading img{display:none}.slick-slide.dragging img{pointer-events:none}.slick-vertical .slick-slide{display:block;height:auto;border:0}
    @charset 'UTF-8';.slick-dots,.slick-next,.slick-prev{padding:0;display:block;position:absolute}.slick-dots li,.slick-dots li button,.slick-next,.slick-prev{cursor:pointer;width:20px;height:20px}.slick-dots li button:before,.slick-next:before,.slick-prev:before{font-family:slick;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.slick-loading .slick-list{background:url('./ajax-loader.gif') center center no-repeat #fff}.slick-dots li button,.slick-next,.slick-next:focus,.slick-next:hover,.slick-prev,.slick-prev:focus,.slick-prev:hover{color:transparent;background:0 0;outline:0}@font-face{font-family:slick;font-weight:400;font-style:normal;src:url('./fonts/slick.eot');src:url('./fonts/slick.eot?#iefix') format('embedded-opentype'),url('./fonts/slick.woff') format('woff'),url('./fonts/slick.ttf') format('truetype'),url('./fonts/slick.svg#slick') format('svg')}.slick-next,.slick-prev{font-size:0;line-height:0;top:50%;-webkit-transform:translate(0,-50%);-ms-transform:translate(0,-50%);transform:translate(0,-50%);border:none}.slick-dots li button:focus:before,.slick-dots li button:hover:before,.slick-next:focus:before,.slick-next:hover:before,.slick-prev:focus:before,.slick-prev:hover:before{opacity:1}.slick-next.slick-disabled:before,.slick-prev.slick-disabled:before{opacity:.25}.slick-next:before,.slick-prev:before{font-size:20px;line-height:1;opacity:.75;color:#fff}.slick-prev{left:-25px}[dir=rtl] .slick-prev{right:-25px;left:auto}.slick-prev:before,[dir=rtl] .slick-next:before{content:'←'}.slick-next:before,[dir=rtl] .slick-prev:before{content:'→'}.slick-next{right:-25px}[dir=rtl] .slick-next{right:auto;left:-25px}.slick-dotted.slick-slider{margin-bottom:30px}.slick-dots{bottom:-25px;width:100%;margin:0;list-style:none;text-align:center}.slick-dots li{position:relative;display:inline-block;margin:0 5px;padding:0}.slick-dots li button{font-size:0;line-height:0;display:block;padding:5px;border:0}.slick-dots li button:focus,.slick-dots li button:hover{outline:0}.slick-dots li button:before{font-size:6px;line-height:20px;position:absolute;top:0;left:0;width:20px;height:20px;content:'•';text-align:center;opacity:.25;color:#000}.slick-dots li.slick-active button:before{opacity:.75;color:#000}
  }
`

export default GlobalStyles
